import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'app-form-label',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <label class="form-label" [class.required-label]="required" [style.marginBottom.px]="margin">
            <ng-content></ng-content>
        </label>
    `,
    styles: [`
        :host {
            display: block;
        }
    `]
})

export class FormLabelComponent {
    @Input() required: boolean;

    /* Возможность задать кастомный отступ */
    @Input() margin: number;
}
